module.exports = __webpack_public_path__ + "media/images/icons/outlined/radius-setting-25777e118c821731b76f075448087b65.svg";